import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Container,Row, Col,Form,Button,Alert,FormGroup,Label,Input} from 'reactstrap';

import {addAddresses} from '../actions/addressActions'
import { Link } from 'react-router-dom';

class Addresse extends Component {

  submit = e =>{
      e.preventDefault();
      let {addAddresses} = this.props

      let datas = new FormData(document.querySelector('#form-adresse'));
      sessionStorage.setItem("btn_ok", "ok");
      addAddresses(datas)
  }

  render() {

     let {login,adresse2} = this.props.userState;
     let {addresse} = this.props.addresses;
    
    return (
          <div>
            <Container className="mb-4 page-addresse">
              
                  <Row>
                      <Col xs="12" md="10" lg="10">
                          <Form onSubmit={this.submit} id="form-adresse" style={{ "maxWidth": 900 }} className="mx-auto">
                            {addresse.ckeck ? 
                              <h2 className="mb-4 text-center">Modifier d'un adresse</h2> 
                              : 
                              <h2 className="mb-4 text-center">Nouvelle adresse</h2>
                            }
                            {login.isLogin ? <Input type="hidden" id="id_customer" name="id_customer" defaultValue={login.data.id} /> : ""}
                            <Input type="hidden" name="id" defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].id : null} />
                            <FormGroup row>
                              <Label for="alias" sm={3} className="text-right">Alias : </Label>
                              <Col sm={8}>
                                <Input
                                  type="text"
                                  id="alias"
                                  name="alias"
                                  defaultValue={adresse2.fetching ? (adresse2.data && adresse2.data.length > 0 ? adresse2.data[0].alias : null) : null}
                                />
                                <small>Optionnel</small>
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="lastname" sm={3} className="text-right">Nom : </Label>
                              <Col sm={8}>
                              {adresse2.fetching ?
                                <Input
                                  type="text"
                                  id="lastname"
                                  name="lastname"
                                  defaultValue={(adresse2.data && (adresse2.data.length > 0)) ? adresse2.data[0].lastname : (login.isLogin ? login.data.lastname : null)}
                                />
                                : 
                                <Input type="text" id="lastname" name="lastname" defaultValue={login.isLogin ? login.data.lastname : null}/> 
                              }
                               
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="firstname" sm={3} className="text-right">Prénom : </Label>
                              <Col sm={8}>
                                {adresse2.fetching ?
                                <Input
                                  type="text"
                                  id="firstname"
                                  name="firstname"
                                  defaultValue={(adresse2.data && (adresse2.data.length > 0)) ? adresse2.data[0].firstname : (login.isLogin ? login.data.firstname : null)}
                                />
                                : 
                                <Input type="text" id="firstname" name="firstname" defaultValue={login.isLogin ? login.data.firstname : null}/> 
                              }
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="company" sm={3} className="text-right">Société : </Label>
                              <Col sm={8}>
                                <Input
                                  type="text"
                                  id="company"
                                  name="company"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].company : null}
                                />
                                <small>Optionnel</small>
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="vat_number" sm={3} className="text-right">Numéro de TVA : </Label>
                              <Col sm={8}>
                                <Input
                                  type="number"
                                  id="vat_number"
                                  name="vat_number"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].vat_number : null}
                                />
                                <small>Optionnel</small>
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="addresse" sm={3} className="text-right">Addresse : </Label>
                              <Col sm={8}>
                                <Input
                                  type="text"
                                  id="addresse"
                                  name="addresse"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].address1 : null}
                                />
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="postcode" sm={3} className="text-right">Code postal : </Label>
                              <Col sm={8}>
                                <Input
                                  type="number"
                                  id="postcode"
                                  name="postcode"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].postcode : null}
                                />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="city" sm={3} className="text-right">Ville : </Label>
                              <Col sm={8}>
                                <Input
                                  type="text"
                                  id="city"
                                  name="city"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].city : null}
                                />
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                              <Label for="phone" sm={3} className="text-right">Téléphone : </Label>
                              <Col sm={8}>
                                <Input
                                  type="text"
                                  id="phone"
                                  name="phone"
                                  defaultValue={adresse2.fetching && (adresse2.data && adresse2.data.length > 0) ? adresse2.data[0].phone : null}
                                />
                                <small>Optionnel</small>
                              </Col>
                            </FormGroup>
                            <FormGroup row>
                            <Col sm={{ offset: 9 }}  className="d-flex">
                                {addresse.ckeck ? 
                                  <Button
                                    color="primary"
                                    tag="input"
                                    type="submit"
                                    value="Modifier"
                                  />
                                  : 
                                  <Button
                                    color="primary"
                                    tag="input"
                                    type="submit"
                                    value="Enregistrer"
                                  />
                                }
                                <Link to={"/user"} className="ml-2 btn btn-primary">Retour</Link>
                              </Col>
                            </FormGroup>
                          </Form>
                          {addresse.check ?
                            <Alert color="success" className="my-4 mx-4 text-center px-4 py-4">
                                  Votre information a bien été envoyé avec succès.
                            </Alert>
                            :null
                          }
                      </Col>
                  </Row>
            
            </Container>
          </div>
    )
  }
}


function mapStateToProps({addressReducer,userReducer}) {
  return {
    addresses: addressReducer,
    userState: userReducer,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    addAddresses: bindActionCreators(addAddresses, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Addresse);



// WEBPACK FOOTER //
// ./src/components/Addresse.js